import { render, staticRenderFns } from "./StandardMatter.vue?vue&type=template&id=02f4c156&scoped=true&"
import script from "./StandardMatter.vue?vue&type=script&lang=js&"
export * from "./StandardMatter.vue?vue&type=script&lang=js&"
import style0 from "./StandardMatter.vue?vue&type=style&index=0&id=02f4c156&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f4c156",
  null
  
)

export default component.exports